import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/client/clientwallet`;
  const data = {
    auth_key: auth_key,
    action: action,
    client_id: values && values.client_id ? values.client_id : "",
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const clientwalletApiController = {
  view,
};

export default clientwalletApiController;
